import Button from 'components/ui/Button/Button';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ScreenshotSupport from './ScreenshotSupport';
import MaximizeModal from './MaximizeModal';
import useDraggableModal from 'hooks/useDraggableModal';

interface ConfirmDialogProps {
  title: string;
  openModal: boolean;
  close: () => void;
  onConfirm: () => void;
}

const ConfirmDialog: FC<ConfirmDialogProps> = ({ title, openModal, close, ...props }) => {
  const { t } = useTranslation();
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);

  return (
    <div>
      {openModal && (
        <div
          className="modal-overlay modal-overlay-top modal-maximizable"
          ref={modalOverlayRef}
          onClick={(e) => e.target === e.currentTarget && close()}
        >
          <div ref={modalRef} className={'modal active'} style={modalStyle}>
            <div
              className={'modal-title  draggable-modal-handle' + (isDragging ? ' dragging' : '')}
              {...dragHandleProps}
            >
              <div>
                <span className="title">{title}</span>
              </div>
              <div data-no-drag="true">
                <ScreenshotSupport />
                <MaximizeModal modalOverlayRef={modalOverlayRef} />
                <FontAwesomeIcon icon={faTimes} onClick={() => close()} />
              </div>
            </div>
            <div className="modal-content">
              <div className="text-md text-bold">{t('mo.are_you_sure')}</div>
            </div>

            <div className="modal-footer">
              <Button
                className="btn btn-danger ml-0 mr-a"
                title={t('confirm')}
                onClick={() => props.onConfirm()}
              />
              <Button className="btn btn-default" title={t('close')} onClick={() => close()} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmDialog;
